module.exports = __webpack_public_path__ + "static/media/xr_aviation_portfolio_laptop.92802794.png";